//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
export default {
  name: 'Processrecord',
  components: {},
  props: {
    datas: {
      type: Array,
      required: true,
      default: null
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    // 获取间隔天数
    getInterValDay: function getInterValDay(end, start) {
      if (!end || !start) {
        return '-';
      }
      var startDate = dayjs(start).unix();
      var endtDate = dayjs(end).unix();
      var diff = endtDate - startDate;
      var day = 60 * 60 * 24;
      var hour = 60 * 60;
      var min = 60;
      var days = Math.floor(diff / day);
      var remainderHour = diff % day;
      var hours = Math.floor(remainderHour / hour);
      var remainderMin = diff % hour;
      var mins = Math.floor(remainderMin / min);
      var seconds = diff % day;
      if (days !== 0) {
        return days + "天" + hours + "小时" + mins + "分钟";
      } else if (hours !== 0) {
        return hours + "小时" + mins + "分钟";
      } else if (mins !== 0) {
        return mins + "分钟";
      } else {
        return seconds + "秒";
      }
    }
  }
};